module.exports = __webpack_public_path__ + "images/state-heroes/mobile/WV.webp";